import { BASE_URL } from "../services/config";

export const urlHelper = {
  isHeaderlessUrl,
  getHubUrl,
};

const headerlessPages = ["/redirect", "/"];

function isHeaderlessUrl(url: string) {
  return headerlessPages.indexOf(url) > -1 ;
}

function getHubUrl() {
  return `${BASE_URL}/api/plexoHub`;
}
